import React, {useEffect, useState} from 'react';
import classNames from 'classnames/index';
import {Link, withRouter} from 'react-router-dom';

import NavbarRight from './navbarRight';
import NavbarXs from './navbarXs';

import logo from '../assets/logo-darkblue.svg';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTimes} from "@fortawesome/free-solid-svg-icons";
import LoginSignupModal from "../loginSignup/loginSignupModal";
import {Modal} from "react-bootstrap";
import {connect} from "react-redux";
import {closeLoginModal, refreshAuth} from "../user/currentUserActions";
import PropTypes from "prop-types";

const Navbar = ({history, loginSignupModalTab, closeLoginModal, refreshAuth, setLanguage}) => {
  useEffect(() => {
    refreshAuth();
  }, []);

  const [isXsNavOpen, setIsXsNavOpen] = useState(false);

  history.listen(() => {
    setIsXsNavOpen(false);
  });

  const navbarClasses = classNames({
    navbar: true,
    'm-show-xs-nav': isXsNavOpen,
    'm-landing': true
  });

  const logout = () => {
    localStorage.removeItem('refreshToken');
    window.location = '/';
  };

  return (
    <>
      <div className={navbarClasses}>
        <div className="container-fluid">
          <Link to="/">
            <div className="navbar__logo">
              <img
                src={logo}
                alt="Logo"
              />
            </div>
          </Link>

          <NavbarRight
            setLanguage={setLanguage}
            setIsXsNavOpen={setIsXsNavOpen}
            isXsNavOpen={isXsNavOpen}
            logout={logout}
          />
        </div>
      </div>

      <NavbarXs isXsNavOpen={isXsNavOpen} logout={logout} setLanguage={(lang) => {
        setIsXsNavOpen(false);
        setLanguage(lang);
      }}/>

      <Modal show={!!loginSignupModalTab} onHide={closeLoginModal}>
        <div onClick={closeLoginModal} className="b-modal-close">
          <FontAwesomeIcon icon={faTimes} size="lg"/>
        </div>

        <LoginSignupModal/>
      </Modal>
    </>
  );
};

Navbar.propTypes = {
  setLanguage: PropTypes.func.isRequired,
};

Navbar.defaultProps = {};

const mapDispatchToProps = {
  closeLoginModal,
  refreshAuth,
};

function mapStateToProps(state) {
  return {
    loginSignupModalTab: state.currentUser.loginSignupModalTab,
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Navbar));
